import { HTMLAttributes, ReactNode } from 'react';
import styles from './Collapsible.module.css';

// A height-animated expand/collapse region. When `open` flips, the grid-rows
// 0fr→1fr trick transitions to the content's natural height (no measuring),
// while the inner wrapper clips the overflow and fades. Content stays mounted
// so it animates both ways; it's `aria-hidden` while closed. Purely a layout
// primitive — the caller owns the toggle button and `open` state.
export interface CollapsibleProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  open: boolean;
  children?: ReactNode;
  innerClassName?: string;
}

export function Collapsible({ open, children, className, innerClassName, ...rest }: CollapsibleProps) {
  return (
    <div
      className={[styles.root, className].filter(Boolean).join(' ')}
      data-open={open}
      aria-hidden={!open}
      {...rest}
    >
      <div className={[styles.inner, innerClassName].filter(Boolean).join(' ')}>{children}</div>
    </div>
  );
}
